<div nz-col nzSpan="24" class="task-item shadowed-on-hover">
  <nz-skeleton [nzAvatar]="false" [nzActive]="true" [nzTitle]="true" [nzLoading]="isLoading">
    <div class="task-item-grid">
      <div>
        <div class="task-item-block">
          <span class="f-s-1-1r">
            <!-- <b>{{(workQueueItem.serviceTask == 'proposal_ManualUw' && workQueueItem.serviceTask == 'proposal_DataEntry')? workQueueItem.proposalNum : "-"}}</b>&nbsp; -->

            <b>
              <!-- {{workQueueItem?.proposalNum}}</b>&nbsp; -->

              <!-- <nz-tag [nzColor]="'blue'">{{workQueueItem.baseProductFamilyDesc}}</nz-tag> -->
              <!-- <b
              *ngIf="workQueueItem.serviceTask != 'proposal_ManualUw' && workQueueItem.serviceTask != 'proposal_DataEntry'"> -->
              <label  *ngIf="inboxFullPrivilege" id="checkBox" nz-checkbox [(ngModel)]="workQueueItem['selected']" 
                nzValue="workQueueItem.id" (ngModelChange)="emitSelectedTask($event,workQueueItem.id)" ngDefaultControl>
                {{workQueueItem.serviceTask == 'proposal_ManualUw'? workQueueItem.proposalNum : workQueueItem.proposalNum}}
              </label>
              <!-- <label nz-checkbox>
              {{workQueueItem.serviceTask == 'claimIntimation'? workQueueItem.intimationNum : workQueueItem.claimNum}}
              </label> -->
            </b>&nbsp;
            <!-- <nz-tag
              *ngIf="workQueueItem.serviceTask != 'proposal_ManualUw' && workQueueItem.serviceTask != 'proposal_DataEntry'"
              [nzColor]="'blue'">
              {{(workQueueItem.eventTypeCd | technicalTranslate)|| '' }}
            </nz-tag> -->
            <nz-tag [nzColor]="'green'">
              <i nz-icon nzType="heart"></i> {{(workQueueItem.baseProductCd | technicalTranslate) || '' }}</nz-tag>

              <!-- *ngIf="workQueueItem.serviceTask != 'proposal_ManualUw' && workQueueItem.serviceTask != 'proposal_DataEntry'" -->
              
            <nz-tag [nzColor]="'blue'" style="position: absolute; right: 15px;">
              <i nz-icon nzType="heart"></i>
              {{workQueueItem.serviceTask != 'proposal_ManualUw' && workQueueItem.serviceTask != 'proposal_DataEntry'? (workQueueItem.taskDesc) : workQueueItem.taskDescription || '' }}
            </nz-tag>

          </span>
        </div>
        <div class="grid grid-3x p-t-10 p-b-5">
          <ng-container *ngFor="let item of visibleInboxAttributes">
            <div>
              <strong class="c-s-heading">{{item.description}}</strong>
              <span
                *ngIf="item.key!=='earlyClaimFl'"  [class.highlight]="item.isSelected">{{workQueueItem[item.key] ? 
                  (item.formatter ? (workQueueItem[item.key] | CurrencyFormatter : workQueueItem['currencyCd']) : 
                  item.date ? (workQueueItem[item.key] | date : appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR) : 
                  item.dateTime ? (workQueueItem[item.key] | date : 'medium') : 
                  item.inDays ? (workQueueItem[item.key] + ' days') : ( item.ignoreTechnicalTranslate? (workQueueItem[item.key]) : (workQueueItem[item.key] | technicalTranslate))) : '-'}}</span>
              <span *ngIf="item.key==='earlyClaimFl'">{{workQueueItem[item.key]?'Early':'Non-early'}}</span>
              <!-- {{workQueueItem[item.key]?(item.formatter? (workQueueItem[item.key] | CurrencyFormatter) : item.date? (workQueueItem[item.key] | date) :  (workQueueItem[item.key] | technicalTranslate)) : ''}} -->
            </div>
          </ng-container>
          <!-- <div *ngIf="workQueueItem.serviceTask == 'proposal_ManualUw'">
            <strong class="c-s-heading">Source</strong>
            {{source}}
          </div> -->
          <!-- <div *ngIf="workQueueItem.serviceTask == 'claimIntimation'">
            <strong class="c-s-heading">Intimation Number</strong>
            {{workQueueItem[key] || '' |translate }}
          </div>
          <div *ngIf="workQueueItem.serviceTask == 'claimRegistration'">
            <strong class="c-s-heading">Claim Number</strong> {{workQueueItem.claimNum || '' |translate }}
          </div>
          <div>
            <strong class="c-s-heading">Policy Commencement</strong> 12 Nov 2018, 10:15 AM</div>
          <div>
            <strong class="c-s-heading">Insured Name</strong>{{workQueueItem.insuredName || '' |translate }}</div>
          <div>
            <strong class="c-s-heading">Claimed Amount </strong> Rs. 1.2 Cr</div> -->
        </div>
      </div>
      <div class="tags-equi-width">
        <nz-tag *ngIf="inboxFullPrivilege" class="d-b w-100-pc-force" [nzColor]="'orange'"><span translate>SLA</span>:
          {{workQueueItem.SLA|| '' |translate }}</nz-tag>
        <nz-tag *ngIf="inboxFullPrivilege" class="d-b w-100-pc"><span translate>Complexity</span>:
          {{workQueueItem.complexityScore}}</nz-tag>
        <nz-tag *ngIf="inboxFullPrivilege" class="d-b w-100-pc"><span translate>Priority</span>:
          {{(workQueueItem.priority | technicalTranslate) || '' |translate }}
        </nz-tag>
      </div>
      <div>
        <button nz-button nzType="primary" class="w-100-pc b-r-0" [nzLoading]="_openingCase"
          (click)="openTransactionDetails(workQueueItem.serviceTask,workQueueItem.entityGuid,workQueueItem.id,workQueueItem.baseProductCd)">
          <i nz-icon nzType="eye" nzTheme="outline"></i> <span translate>Open</span></button>

        <button *ngIf="inboxFullPrivilege" nz-button nzType="default" class="w-100-pc b-r-0"
          (click)="workQueueItem.isCollapsed=!workQueueItem.isCollapsed;setScore(workQueueItem)">
          <i nz-icon nzType="safety" nzTheme="outline"></i> <span translate>Analyze</span></button>

          <button *ngIf="inboxFullPrivilege" nz-button nzType="default" class="w-100-pc b-r-0" style="padding-left: 5px;"  (click)="activityPanel(1)">
          <i nz-icon nzType="profile" ></i> <span translate>Activity Timeline</span></button>
          <button *ngIf="inboxFullPrivilege && workQueueItem.statusCd != 'DRAFT'" nz-button nzType="default" class="w-100-pc b-r-0" style="padding-left: 5px;"  (click)="openRiskSummary(1)">
            <i nz-icon nzType="profile" ></i> <span translate>Risk Summary</span></button>
      </div>
    </div>
    <div *ngIf="enableAnalyticsPanel && data && workQueueItem.isCollapsed">
      <app-ui-analytics-tab [workQueueItem]="workQueueItem" [IO]="data" [fraud]="fraudScore" [propensityScore]="propensity" [recommendation]="recommendation"></app-ui-analytics-tab>
    </div>
    <div *ngIf="enableRiskSummary">
      <ng-container *ngIf="isRiskSummaryLoading">
        <div class="widget-loading" *ngFor="let i of [1];" style="height:150px">
          <p><i nz-icon nzType="loading" nzTheme="outline"></i>&nbsp; Loading ...</p>
        </div>
      </ng-container>
      <div *ngIf="!isRiskSummaryLoading">
      <app-underwriter-review [inputDataForEdit]="policyData" [configData]="configData"
      [transactionState]="'workbench'" [RequirementEntityGuid]="workQueueItem.entityGuid" (emitStepToEnable)="enableStep($event)" [policyData]="policyData">
      </app-underwriter-review>
      </div>
    </div>
    <!-- Footer Tags -->
    <!-- <div class="grid grid-gap-20 grid-3x p-t-b-2">
      <nz-tag *ngIf="inboxFullPrivilege" class="d-b w-100-pc-force" [nzColor]="'orange'"><span translate>SLA</span>:
        {{workQueueItem.SLA|| '' |translate }}</nz-tag>
      <nz-tag *ngIf="inboxFullPrivilege" class="d-b w-100-pc"><span translate>Complexity</span>:
        {{workQueueItem.complexityScore}}</nz-tag>
      <nz-tag *ngIf="inboxFullPrivilege" class="d-b w-100-pc"><span translate>Priority</span>:
        {{(workQueueItem.priority | technicalTranslate) || '' |translate }}
      </nz-tag>
    </div> -->
    <!-- Footer -->
    <div class="task-item-foot">
      <span><span translate>Created Date</span>: {{(workQueueItem.startDt | date)|| ''}}</span>
      <!-- <span><span translate>Last Re-assigned by</span>:
        {{(workQueueItem.lastReassignedBy === null ? '-': workQueueItem.lastReassignedBy )|| ''}}</span> -->
        <span *ngIf="workQueueItem.lastReassignedBy !== null">
          <span translate>Re-Assigned By</span>: {{workQueueItem.lastReassignedBy}}
        </span>
        
      <span><span translate>Assigned to</span>: {{workQueueItem.taskUser|| ''}}</span>
    </div>
  </nz-skeleton>
  <!--Activity log  -->
  <nz-drawer [nzClosable]="true" [nzWidth]="390" [nzPlacement]="'right'" nzTitle="Activity Timeline"
  [nzVisible]="activityPanelOpen" (nzOnClose)="activityPanel(0)">
    <ng-container *nzDrawerContent>
      <app-claims-activity-timeline [IO]="workQueueItem" transactionState="_state"></app-claims-activity-timeline>
    </ng-container>
  </nz-drawer>
</div>